import { render, staticRenderFns } from "./input-bar-material.vue?vue&type=template&id=646fa190&scoped=true&"
import script from "./input-bar-material.vue?vue&type=script&lang=ts&"
export * from "./input-bar-material.vue?vue&type=script&lang=ts&"
import style0 from "./input-bar-material.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./input-bar-material.vue?vue&type=style&index=1&id=646fa190&scoped=true&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646fa190",
  null
  
)

export default component.exports